/**
 * Wording for the emailed-code screen. The same code flow serves two cases:
 * verifying a new address, and confirming a password sign-in to a verified
 * account (every password sign-in now asks for a code).
 */
export interface VerifyEmailCopy {
  heading: string;
  intro: string;
  submit: string;
  resent: string;
  failed: string;
  deliveryFailed: string;
}

export function verifyEmailCopy(reason?: string | null): VerifyEmailCopy {
  if (reason === "sign_in") {
    return {
      heading: "Check your email",
      intro: "To finish signing in, enter the six-digit code we sent to ",
      submit: "Sign in",
      resent: "Sign-in code sent.",
      failed: "Sign-in failed. Please try again.",
      deliveryFailed: "The sign-in code could not be sent. Try resend.",
    };
  }
  return {
    heading: "Verify your email",
    intro: "We sent a six-digit code to ",
    submit: "Verify email",
    resent: "Verification email sent.",
    failed: "Email verification failed. Please try again.",
    deliveryFailed:
      "Your account was created, but the email could not be sent. Try resend.",
  };
}
